(() => {
  const searchPath = /\/search\/?$/;
  const readableQuery = (value) => {
    const match = value.match(/^title:"([^"]+)" OR body:"([^"]+)" OR tag:"([^"]+)"$/i);
    return match && match[1] === match[2] && match[2] === match[3] ? match[1] : value;
  };
  const getHidden = (form, name) => {
    let input = form.querySelector(`input[name="${name}"]`);
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      form.appendChild(input);
    }
    return input;
  };
  const prepareForms = () => {
    const params = new URLSearchParams(window.location.search);
    document.querySelectorAll('form').forEach((form) => {
      const action = new URL(form.action, window.location.origin);
      if (!searchPath.test(action.pathname)) return;
      if (!form.querySelector('input[name="q"]')) return;
      getHidden(form, 'type').value = 'product';
      const display = getHidden(form, 'display_q');
      const query = form.querySelector('input[name="q"]');
      const readable = readableQuery(params.get('display_q') || query.value);
      display.value = readable;
      if (/^(title|body|tag):/i.test(query.value.trim())) query.value = readable;
    });
  };
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const action = new URL(form.action, window.location.origin);
    if (!searchPath.test(action.pathname)) return;
    const query = form.querySelector('input[name="q"]');
    if (!query) return;
    getHidden(form, 'type').value = 'product';
    const display = getHidden(form, 'display_q');
    const displayQuery = form.querySelector('input[name="display_q"]')?.value || '';
    const raw = readableQuery((query.type === 'search' ? query.value : displayQuery || query.value).trim());
    display.value = raw;
    if (/^(title|body|tag):/i.test(query.value.trim())) return;
    const phrase = raw.replace(/^["']|["']$/g, '').trim();
    const words = phrase.split(/\s+/).filter(Boolean);
    if (!words.length || !words.every((word) => /^[\p{L}\p{N}][\p{L}\p{N}-]*$/u.test(word))) return;
    const quotedPhrase = words.join(' ');
    query.value = ['title', 'body', 'tag'].map((field) => field + ':"' + quotedPhrase + '"').join(' OR ');
  }, true);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', prepareForms, { once: true });
  } else {
    prepareForms();
  }
})();